import React, { useState } from 'react'
import './InnovativeSolution.css'
import Slider from 'react-slick'
import { FaQuoteLeft } from 'react-icons/fa'

const Innovativetestimonials = () => {
  const [testimonial] = useState([
    {
      review:
        "Farmer's City has helped me increase my crop yields by 20% and reduce my water consumption by 30%.",
      customer: 'Ranjan, Odisha'
    },
    {
      review:
        "The solar irrigation pump from Farmer's City has been a game-changer for my farm. I have cut down my irrigation costs by 35%.",
      customer: 'Sujata, Maharashtra'
    },
    {
      review:
        "The smart irrigation controller from Farmer's City has saved me a significant amount of water and reduced my energy costs.",
      customer: 'Subhalakshmi, Telangana'
    }
  ])

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  }

  return (
    <div className=' py-5 customer-testimonial'>
      <div className='container mt-4 mb-4 clr_dark_green'>
        <h2 className='ff_heebo fw-bold fs_7xl clr_dark_blue text-center'>
          What Our <span className='clr_dark_green'> Customers Say</span>
        </h2>

        <Slider className='mt-5' {...settings}>
          {testimonial.map((value, index) => (
            <div key={index} className='px-4 h-100'>
              <div className='testimonial-card h-500'>
                <FaQuoteLeft className='quote-icon' />
                <p className='review-text'>{value.review}</p>
                <p className='customer-name'>— {value.customer}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}

export default Innovativetestimonials
